import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { environment } from 'environments/environment';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ImageSliderComponent {
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  images: any;
  API_FILES = environment.API_FILES;

  constructor(
    public matDialogRef: MatDialogRef<ImageSliderComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,

  ) {
    this.images = _data;
  }

  ngOnInit(): void {
  }

}
